import api from "../api";
import {iniciarRequisicao} from '../../helpers/index';

class TempoCoberturaPorCurvas {
  async getListaFull(headers) {
    const response = await api.get("/compras/tempo-cobertura-por-curvas", { headers });
    return response;
  }

  async deleteMultiplos(headers, params) {
    const response = await api({
      method: 'delete',
      url: `/compras_delete_multiplos_tempo_cobertura`,
      headers,
      data: params
    });
    return response;
  }

  async store(headers, params) {
    const response = await api({
      method: 'post',
      url: '/compras/tempo-cobertura-por-curvas',
      headers,
      data: params
    });
    return response;
  }

  async aplicarTempoCobertura(params) {
    const headers = iniciarRequisicao();

    const response = await api({
      method: 'post',
      url: '/compras/tempo-cobertura-por-curvas/aplica-em-produtos',
      headers,
      data: params
    });
    return response;
  }
}

export default new TempoCoberturaPorCurvas();
